import { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { findEntityData } from "../../api/apiService";
import logo from "../../assets/Group 1.webp";
import arrowImg from "../../assets/orange-arrow.webp";
import arrowWhiteImg from "../../assets/white-arrow.webp";

const Header = () => {
    const [section1, setSection1] = useState()
    const findData = async () => {
        const res = await findEntityData('sss_home_header')
        setSection1(res?.data?.[0])
    }

    useEffect(() => {
        findData()
    }, [])

    const { ref, inView } = useInView({
        triggerOnce: false,
        threshold: 0.3,
    });
    return (
        <div className="!h-auto !lg:h-screen">
            {section1 &&
                <section className="hero py-16 px-4 text-center md:text-left overflow-hidden">
                    <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
                        <div className="max-w-xl">
                            <div className="max-w-3xl animate-fadeInUp">
                                <h3 className="text-2xl md:text-3xl font-semibold text-[#F37934] leading-snug p-4 md:whitespace-nowrap">
                                    {section1?.heading}
                                </h3>
                                <h3 className="text-2xl md:text-3xl font-normal text-[#F37934] leading-snug p-4">
                                    {section1?.subHeading}
                                </h3>
                            </div>
                            <Link to="/" className="hidden md:flex items-center"
                                data-aos="fade-right"
                                data-aos-offset="100"
                                data-aos-duration="800"
                                data-aos-easing="ease-out" >
                                <img
                                    src={logo}
                                    alt="Success Logo"
                                    className="h-10 w-24"
                                />
                                <div className="flex flex-col py-12">
                                    <h2 className="text-[#F37934] font-bold tracking-widest font-nimbus text-2xl md:text-4xl lg:text-4xl">
                                        SUCCESS
                                    </h2>
                                    <p className="font-poppins text-[#F37934] tracking-tight text-[7px] sm:text-[10px] md:text-[10px] lg:text-[10px]">
                                        Shipping Services (Chennai) Pvt Ltd
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="w-full font-semibold flex justify-center mt-6 " >
                        <Link
                            to={section1?.buttonRedirectLink}
                            className="group inline-flex items-center gap-2 whitespace-nowrap px-6 py-3 text-[#F37934] rounded-full border border-[#F37934] hover:bg-[#F37934] hover:text-white transition"
                            data-aos="zoom-in"
                            data-aos-duration="800"
                            data-aos-easing="ease-out"
                            data-aos-offset="100"
                        >
                            <span className="group-hover:text-white">
                                {section1?.buttonName}
                            </span>
                            <img
                                src={arrowImg}
                                alt="arrow"
                                className="w-6 h-3 inline-block group-hover:hidden"
                            />
                            <img
                                src={arrowWhiteImg}
                                alt="arrow white"
                                className="w-6 h-3 inline-block hidden group-hover:inline-block"
                            />
                        </Link>
                    </div>
                </section>
            }
            {section1?.data &&
                <section className="stats py-12 px-4 overflow-hidden" ref={ref} >
                    <div
                        className="container mx-auto grid grid-cols-1 sm:grid-cols-3 text-center 
             bg-gradient-to-r from-transparent via-[#FFFFFF] to-transparent"
                    >
                        <div className="p-6 relative">
                            <h2 className="text-2xl md:text-3xl font-bold text-[#F37934]">
                                {inView && (
                                    <CountUp
                                        start={0}
                                        end={section1?.data?.[0]?.count}
                                        duration={2.5}
                                        formattingFn={(value) => section1?.data?.[0]?.count}
                                        suffix=" "
                                    />
                                )}{" "}
                                <span className="font-cinzel text-[#56453F]">{section1?.data?.[0]?.notation}</span>
                            </h2>
                            <p className="font-semibold">{section1?.data?.[0]?.content}</p>
                            <span className="hidden sm:block absolute right-0 top-1/2 -translate-y-1/2 h-12 w-px bg-[#C4C4C4]"></span>
                        </div>

                        <div className="p-6 relative">
                            <h2 className="text-2xl md:text-3xl font-bold text-[#F37934]">
                                {inView && (
                                    <CountUp
                                        formattingFn={(value) => section1?.data?.[1]?.count}
                                        start={0} end={section1?.data?.[1]?.count} duration={2.5} suffix=" " />
                                )}
                                <span className="font-cinzel text-[#56453F]"> {" "}{section1?.data?.[1]?.notation}</span>
                            </h2>
                            <p className="font-semibold">{section1?.data?.[1]?.content}</p>
                            <span className="hidden sm:block absolute right-0 top-1/2 -translate-y-1/2 h-12 w-px bg-[#C4C4C4]"></span>
                        </div>

                        <div className="p-6">
                            <h2 className="text-2xl md:text-3xl font-bold text-[#F37934]">
                                {inView && (
                                    <CountUp
                                        formattingFn={(value) => section1?.data?.[2]?.count}
                                        start={0} end={section1?.data?.[2]?.count} duration={3} suffix=" " />
                                )}
                                <span className="font-cinzel text-[#56453F]"> {" "}{section1?.data?.[2]?.notation}</span>
                            </h2>
                            <p className="font-semibold">{section1?.data?.[2]?.content}</p>
                        </div>
                    </div>
                </section>
            }
        </div>
    )
}

export default Header
